import script from "./ServiceLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceLogo.vue?vue&type=script&setup=true&lang=js"

import "./ServiceLogo.vue?vue&type=style&index=0&id=1a6f063a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a6f063a"]])

export default __exports__